// src/plugins/storage.ts
// Persists plugin install/enable/config state. Local-first: localStorage by default.
// A Supabase-backed implementation can swap in by replacing the `store` object.
const KEY = 'reviewradar.plugins.state.v1';
function readAll() {
    try {
        if (typeof localStorage === 'undefined')
            return { plugins: {} };
        const raw = localStorage.getItem(KEY);
        if (!raw)
            return { plugins: {} };
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object' && parsed.plugins)
            return parsed;
        return { plugins: {} };
    }
    catch {
        return { plugins: {} };
    }
}
function writeAll(full) {
    if (typeof localStorage === 'undefined')
        return;
    localStorage.setItem(KEY, JSON.stringify(full));
}
export function getState(id) {
    return readAll().plugins[id] ?? null;
}
export function setState(id, next) {
    const full = readAll();
    full.plugins[id] = { ...next, updatedAt: new Date().toISOString() };
    writeAll(full);
    emitChange();
}
export function removeState(id) {
    const full = readAll();
    delete full.plugins[id];
    writeAll(full);
    emitChange();
}
export function listStates() {
    return readAll().plugins;
}
const listeners = new Set();
export function subscribe(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
}
function emitChange() {
    listeners.forEach(fn => { try {
        fn();
    }
    catch { /* ignore */ } });
}
// Also listen for cross-tab changes.
if (typeof window !== 'undefined') {
    window.addEventListener('storage', (e) => {
        if (e.key === KEY)
            emitChange();
    });
}
/** Test helper — resets everything. */
export function __clearForTests() {
    if (typeof localStorage !== 'undefined')
        localStorage.removeItem(KEY);
    emitChange();
}
